import moment from 'moment';

export default function getDateAnneeSemaine(anneeSemaine) {
  if (!anneeSemaine) return null;
  return moment(anneeSemaine.toString(), 'GGGGWW');
}
